import React from "react";
import { Table } from "reactstrap";
import CalendarioPersonalImpl from "./CalendarioPersonalImpl";

const Calendario = (props) => {
  const daysInMonth = new Date(props.anno, Number(props.mes) + 1, 0).getDate();
  const diasDelMes = [];
  const labelWeek = ["D", "L", "M", "X", "J", "V", "S"];
  for (let i = 1; i <= daysInMonth; i++) {
    const day = new Date(props.anno, props.mes, i);
    const dayOfWeek = day.getDay();
    const labelOfWeek = labelWeek[dayOfWeek];

    diasDelMes.push({ dia: i, date: day, label: labelOfWeek });
  }

  return (
    <>
      <Table className="table align-items-center table-flush " responsive>
        <thead className="thead-light">
          <th>Empleado</th>
          {diasDelMes.map((dia) => {
            return (
              <th className="p-1 text-center" key={dia.dia}>
                {dia.label}-{dia.dia < 10 ? "0" + dia.dia : dia.dia}
              </th>
            );
          })}
        </thead>
        <tbody>
          {props.empleados.map((empleado) => {
            return (
              <tr key={empleado.id}>
                <td>
                  {" "}
                  {empleado.apellidos}, {empleado.nombre}
                </td>
                <CalendarioPersonalImpl
                  diasDelMes={diasDelMes}
                  empleadoId={empleado.id}
                  anno={props.anno}
                  mes={props.mes}
                  centroId={empleado.centroId}
                ></CalendarioPersonalImpl>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default Calendario;
